import styled from "styled-components";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
`;

export const ShareItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
  width: 100%;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const Title = styled.div`
  color: #1C1C1C;
  text-align: left;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 155.556% */

  margin-top: 4px;
`;

export const PointContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
`;

export const Point = styled.div`
  overflow: hidden;
  color: #1C1C1C;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  b{
    color: #1C1C1C;
  }

  @media screen and (max-width: 400px) {
    font-size: 14px;
  }

  @media screen and (max-width: 350px) {
    font-size: 12px;
  }
`;

export const Collect = styled(AntButton)`
  padding: 2px 8px;
  border-radius: 8px;
  border: none;
  height: 30px;
  background: var(--gradient, linear-gradient(180deg, #00DE00 0%, #008500 97.5%, #008500 98.5%));

  color: #fff;
  font-size: 12px !important;
  line-height: 1.5;
  text-transform: uppercase;

  cursor: pointer;

:disabled {
  color: #999999 !important;
    background: #376F37;
    border:  none !important;
    cursor: not-allowed;
}
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #999;
  margin: 16px 0px;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-left: 5%;
`;

export const ItemBottomBox = styled.div`
margin-top: 10px;
  border-radius: 15px;
  background: #F7F7F7;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
`

export const StepBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 25%;

  svg{
    min-width: 30px;
    width: 30px;
    height: 30px;
  }
`;

export const IconBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;

  position: relative;
`;

export const Number = styled.p`
  width: 40px;
  margin-top: 4px;

  color: #000;
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const FinishLine = styled.div`
  height: 4px;
  background-color: #FB0;
  width: ${(props) => props.width === 0 ? '0px' 
  : props.width === 100 ? `calc(${props.width}% - 30px)`
  : `calc(${props.width}% - ${props.width * 15 / 100}%)`};
`;

export const UnfinishLine = styled.div`
  height: 4px;
  background-color: #D3D3D3;
  width: ${(props) =>
    props.width === 100 ? `calc(${props.width}% - 30px)` 
    : props.width === 0 ? '0px'
    : `calc(${props.width}% - ${props.width * 15 / 100}%)`};
`;

export const CurrentMilestone = styled.p`
  position: absolute;
  top: 0;
  right: calc(50% - 20px);

  color: #000;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const CollectModalTitle = styled.div`
  margin-bottom: 10px;
  color: var(--Text-Primary, #1E1E1E);
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
`;

export const CollectModalQuestion = styled.div`
  display: block;

  color: #616161;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh - 68px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 70px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const NoResultText = styled.div`
  color: #979797;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
`;

export const ShareItemBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

export const BottomText = styled.p`
  overflow: hidden;
  color: #006400;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`

export const TextBtn = styled(AntButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  background: none !important;
  border: none !important;
  padding: 0 !important;

  :hover{
    background: none !important;
    border: none !important;
  }

  svg{
    width: 24px;
    height: 24px;
  }
`